<template>
  <div id="apply">
    <div class="title">
      <!--<div class="text">成为中国最好的</div>-->
      <div class="text">提交需求</div>
    </div>
    <div class="content-wrap">
      <span class="wrap">
        <span class="text-title">姓名</span>
        <input type="text"
               class="name input"
               :class="{active: !!promptMessage.username}"
               v-model="username"
               :placeholder="promptMessage.username || '张三'"
               autocomplete="off">
      </span>
      <span class="wrap">
        <span class="text-title">电话</span>
        <input type="text"
               class="phone input"
               :class="{active: !!promptMessage.phoneNumber}"
               v-model="phoneNumber"
               :placeholder="promptMessage.phoneNumber || '18188888888'"
               autocomplete="off">
      </span>
      <span class="wrap">
        <span class="text-title">公司名</span>
        <input type="text"
               class="phone input"
               :class="{active: !!promptMessage.companyName}"
               v-model="companyName"
               :placeholder="promptMessage.companyName || '奥创软件研究院'"
               autocomplete="off">
      </span>
      <span class="wrap">
        <span class="text-title">功能需求</span>
        <input type="text"
               class="phone input"
               :class="{active: !!promptMessage.intention}"
               v-model="intention"
               :placeholder="promptMessage.intention"
               autocomplete="off">
      </span>
      <span class="wrap">
        <span class="text-title">验证码</span>
        <input type="text"
               class="verify input"
               :class="{active: !!promptMessage.verifyCode}"
               v-model="verifyCode"
               :placeholder="promptMessage.verifyCode || '000000'"
               autocomplete="off">
        <span class="get-verify" @click="getVerify">获取</span>
      </span>
      <span class="button success" v-if="promptMessage.success">{{promptMessage.success}}</span>
      <span v-else class="button" @click="submitApply">提交需求</span>
    </div>
  </div>
</template>

<script>
import Index from './main'

export default {
  name: 'apply',
  ...Index
}
</script>
<style lang="scss">
  @import "./index";
</style>
